import React from 'react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const STEPS = [{
  num: '1',
  title: 'Start Your Order',
  desc: 'Tell us your sport, league, organization, group size, timeline, and what you need.'
}, {
  num: '2',
  title: 'Start Art Mockups',
  desc: 'Submit your colors, logos, design ideas, and instructions so our art team can create initial mockups.'
}, {
  num: '3',
  title: 'Review Samples & Approvals',
  desc: 'Review artwork, product samples, size samples, or production photos where applicable.'
}, {
  num: '4',
  title: 'Submit Team Details',
  desc: 'Confirm sizes, names, numbers, colors, quantities, and final order details.'
}, {
  num: '5',
  title: 'Production & Delivery',
  desc: 'After approval, your order moves into production and delivery based on the timeline.'
}];
export function OrderProcess() {
  return <section className="py-20 bg-white" data-id="element-202">
      <Container data-id="element-203">
        <div className="text-center mb-16" data-id="element-204">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-205">
            How the Order Process Works
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-206"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-207">
            We've built a simple, organized process to ensure your uniforms are
            designed, approved, and delivered accurately.
          </p>
        </div>

        <div className="relative" data-id="element-208">
          {/* Desktop Timeline Line */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-1 bg-gray-200 -z-10" data-id="element-209"></div>

          {/* Mobile Timeline Line */}
          <div className="lg:hidden absolute top-0 left-8 w-1 h-full bg-gray-200 -z-10" data-id="element-210"></div>

          <div className="flex flex-col lg:flex-row justify-between gap-8 lg:gap-4" data-id="element-211">
            {STEPS.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="relative flex lg:flex-col items-start lg:items-center text-left lg:text-center group" data-id="element-212">
                <div className="flex-shrink-0 w-16 h-16 bg-white border-4 border-gray-200 group-hover:border-pts-red rounded-full flex items-center justify-center font-oswald text-2xl font-bold text-gray-400 group-hover:text-pts-red transition-colors duration-300 mb-0 lg:mb-6 z-10 mr-6 lg:mr-0" data-id="element-213">
                  {step.num}
                </div>
                <div data-id="element-214">
                  <h3 className="font-oswald text-xl font-bold text-gray-900 uppercase mb-2" data-id="element-215">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed max-w-[220px]" data-id="element-216">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 bg-gray-50 border border-gray-200 rounded-lg p-6 text-center max-w-3xl mx-auto" data-id="element-217">
          <p className="text-gray-800 font-medium" data-id="element-218">
            <span className="text-pts-red font-bold uppercase mr-2" data-id="element-219">
              Pro Tip:
            </span>
            Planning early helps with art approvals, samples, sizing, and
            production timelines — especially for leagues, large groups, and
            multi-team programs.
          </p>
        </div>
      </Container>
    </section>;
}